import AvatarEditor from 'components/pure/admin/profile/components/AvatarEditor';
import ToastActions from '@store/toast/ToastActions';
import TextField from '@material-ui/core/TextField';
import validateNameToken from 'components/pure/admin/profile/util/validateNameToken';
import {TimezoneAutocomplete} from 'components/pure/admin/TimezoneAutocomplete';
import Button from '@material-ui/core/Button';
import React, {useEffect, useState} from 'react';
import User from 'records/User';
import {useUserProfileContext} from '../ProfileContext';

export default function EditUserInfoForm(props: {
  user: User;
  onEditAvatar: (a: any) => void;
  onEditUser: (u: User) => void;
  onResetPassword: (u: User) => void;
}) {
  const {user: editingUser, onEditAvatar, onEditUser, onResetPassword} = props;
  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    timezone: false,
  });
  const {updateErrorState} = useUserProfileContext();

  const editUser = updatedUser => {
    onEditUser(updatedUser);
  };

  // React to updates in the user object by updating our error state.
  // This allows setting error state in response to the user changing
  // a field AND in response to the reset button being pressed.
  useEffect(() => {
    const newErrors = {
      firstName: !validateNameToken(editingUser.get('firstName')),
      lastName: !validateNameToken(editingUser.get('lastName')),
      timezone: !editingUser.get('timezone'),
    };
    setErrors(newErrors);
    updateErrorState(
      'userForm',
      Object.values(newErrors).some(err => err === true)
    );
  }, [editingUser, updateErrorState]);

  return (
    <div className="form-grouper">
      <AvatarEditor
        onChange={onEditAvatar}
        dropzoneOnDrop={(acceptedFiles, rejectedFiles) => {
          // handle rejected file upload
          if (rejectedFiles.length > 0) {
            ToastActions.addToast({
              type: 'error',
              message: "File type can't be handled.",
            });
          }
        }}
        user={editingUser}
        onClick={() => onEditAvatar}
      />
      <TextField
        label="First Name"
        variant="outlined"
        value={editingUser.firstName}
        onChange={({target: {value}}) => {
          editUser(editingUser.set('firstName', value));
        }}
        error={errors.firstName}
      />
      <TextField
        label="Last Name"
        variant="outlined"
        value={editingUser.lastName}
        onChange={({target: {value}}) => {
          editUser(editingUser.set('lastName', value));
        }}
        error={errors.lastName}
      />
      <TextField label="Email" variant="outlined" value={editingUser.email} disabled />
      <TimezoneAutocomplete
        value={editingUser.timezone}
        setUserZone={tz => {
          editUser(editingUser.set('timezone', tz));
        }}
        error={errors.timezone}
      />
      <div className="button-row">
        <div className="left-side">
          <Button variant="outlined" onClick={() => onResetPassword(editingUser)}>
            Send Password Reset Email
          </Button>
        </div>
      </div>
    </div>
  );
}
